import useSWR from "swr";

import { api, type Me } from "../services/api";

/**
 * Unread iQuest replies to the signed-in user's support tickets (Settings →
 * Help & Support). Drives the violet dot on the user pill and on the mobile
 * menu button. Unlike the bell, it stays set until the reply is opened, so a
 * cleared bell can't hide one. Off during View as, like the bell. Every caller
 * shares one SWR key, so this is a single 60s poll.
 */
export function useSupportReplies(me: Me | undefined): { count: number; label: string } {
  const { data } = useSWR<{ count: number }>(
    me && !me.impersonating ? "/api/feedback/unread-count" : null,
    () => api.feedback.unreadCount(),
    { refreshInterval: 60_000 },
  );
  const count = data?.count ?? 0;
  return { count, label: count === 1 ? "New reply" : `${count} new replies` };
}
